let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ehB5U")).then(() => parcelRequire('g9gwQ'));